import { compositeScoresService as compositeScoresServiceForDibels8 } from '@amplify/dibels8-composite-score';
import { compositeScoresService as compositeScoresServiceForLectura } from '@amplify/lectura-composite-score';
import isEmpty from 'lodash.isempty';
import toPairs from 'lodash.topairs';
import { DIBELS8, IDEL2 } from '../../constants/applications';

const compositeScoresService = {
    [DIBELS8]: compositeScoresServiceForDibels8,
    [IDEL2]: compositeScoresServiceForLectura,
};

/**
 * Transform gatinRulesConfig object to array with next data format
 * [`${grade}_${period}`, ...]
 * @param {Object} config gatingRulesConfig object which contain info about denying gating rule for each grade/period
 * {
        "02": ["EOY", "MOY"],
        "03": ["BOY"],
        "KG": ["BOY", "EOY", "MOY"]
    }
 * @returns {Array} with tranformed data format
    ['02_EOY', '02_MOY', '03_BOY', 'KG_BOY', 'KG_EOY', 'KG_MOY']
 */
const transformGatingRulesConfig = config =>
    toPairs(config).flatMap(([key, value]) => value.map(item => `${key}_${item}`));

export function calculateCompositeForStudent(
    results,
    appName,
    grade,
    period,
    gatingRulesConfig,
    includeGatedScores = true,
) {
    const studentResults = results.filter(result => result.isValid);

    const windowsWithDisabledGatingRules =
        appName === DIBELS8 ? transformGatingRulesConfig(gatingRulesConfig) : [];

    const composite = compositeScoresService[appName].calculateCompositeScoresForStudent(
        studentResults,
        includeGatedScores,
        windowsWithDisabledGatingRules,
    );

    if (isEmpty(composite)) return {};

    const { compositeScore, interpretation } = composite[grade][period].overallStatus;

    return {
        overallInterp: interpretation,
        overallScore: compositeScore,
        gatedMeasuresStatus: composite[grade][period].gatedMeasuresStatus,
    };
}
